<es-details-card [info]="info" [canEdit]="canEdit" [isMissing]="isEmpty" (edit)="goToEdit()">
  <ng-template [ngIf]="bondInfo && (!(singleBondRequest || continuousBondRequest) || hasCanceledBondRequest)">
    <div class="row" *ngIf="bondTypeLabel">
      <div class="col-6 card-label">{{ "LABELS.BOND_TYPE" | translate }}</div>
      <div class="col-6">{{ bondTypeLabel | translate }}</div>
    </div>
    <div class="row" *ngIf="bondInfo?.suretyCode">
      <div class="col-6 card-label">{{ "FORM_LABEL.SURETYCODE" | translate }}</div>
      <div class="col-6">{{ bondInfo.suretyCode }}</div>
    </div>
    <div class="row" *ngIf="isSingleBondType && bondInfo?.referenceNumber">
      <div class="col-6 card-label">{{ "LABELS.REFERENCE_NUMBER" | translate }}</div>
      <div class="col-6">{{ bondInfo.referenceNumber }}</div>
    </div>
    <div class="row" *ngIf="bondInfo?.bondAmount">
      <div class="col-6 card-label">{{ "LABELS.AMOUNT" | translate }}</div>
      <div class="col-6">{{ bondInfo.bondAmount | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}</div>
    </div>
  </ng-template>
  <ng-template [ngIf]="singleBondRequest">
    <div class="row">
      <div class="col-12">{{ singleBondText | translate }}</div>
    </div>

    <div class="row" *ngIf="isShowBR">
      <div class="col-6 card-label">{{ "LABELS.BOND_REQUEST_NUMBER" | translate }}</div>
      <div class="col-6">
        <a href="" [routerLink]="['/bond-requests-management', singleBondRequest?.id]">{{ singleBondRequest?.referenceNumber }}</a>
      </div>
    </div>

    <div class="row" *ngIf="singleBondRequest?.portCode">
      <div class="col-6 card-label">{{ "LABELS.ARRIVAL_PORT" | translate }}</div>
      <div class="col-6">{{ arrivalPort ? arrivalPort.code + " " + arrivalPort.description : singleBondRequest.portCode }}</div>
    </div>
    <div class="row" *ngIf="importer?.entityIdentifier && importer?.entityIdentifierQualifier">
      <div class="col-6 card-label">{{ "FORM_LABEL.IMPORTER_IDENTIFIER" | translate }}</div>
      <div class="col-6">
        {{ ("IDENTIFIER_QUALIFIER." + importer.entityIdentifierQualifier | translate) + " " + importer.entityIdentifier | identifier }}
      </div>
    </div>
    <div class="row" *ngIf="importer?.name">
      <div class="col-6 card-label">{{ "FORM_LABEL.IMPORTER_NAME" | translate }}</div>
      <div class="col-6">{{ importer.name }}</div>
    </div>
  </ng-template>
  <ng-template [ngIf]="continuousBondRequest">
    <div class="row">
      <div class="col-12">{{ "INFO.BN.CONTINUOUS_BOND_PURCHASE_REQUESTED" | translate }}</div>
    </div>
    <div class="row" *ngIf="continuousBondRequest.continuousBondDetails?.importerNumber">
      <div class="col-6 card-label">{{ "FORM_LABEL.IMPORTER_IDENTIFIER" | translate }}</div>
      <div class="col-6">
        {{ continuousBondRequest.continuousBondDetails.importerNumber }}
      </div>
    </div>
    <div class="row" *ngIf="continuousBondRequest.continuousBondDetails?.companyName">
      <div class="col-6 card-label">{{ "FORM_LABEL.IMPORTER_NAME" | translate }}</div>
      <div class="col-6">{{ continuousBondRequest.continuousBondDetails.companyName }}</div>
    </div>
    <div class="row">
      <div class="col-6 card-label">{{ "FORM_LABEL.STATE" | translate }}</div>
      <div class="col-6">
        <div>
          {{ "BOND_REQUEST_STATE." + enumBondRequestState[continuousBondRequest.state] | translate }}
        </div>
        <div class="text-error" *ngIf="bondRequestNotSentError">{{ bondRequestNotSentError | translate }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-6 card-label">{{ "LABELS.PAYMENT_STATE" | translate }}</div>
      <div class="col-6">
        <bill-status [billStatus]="continuousBondRequest.paymentState"></bill-status>
      </div>
    </div>
  </ng-template>
  <div class="error-message" *ngFor="let message of allValidationMessages">{{ "BACK_ERROR." + message.text | translate }}</div>
</es-details-card>
